export var ROLE_VALUES = {
    admin: 'admin',
    purchaser: 'purchaser',
    runner: 'runner',
};
